<template>
  <div class="topbar" :style="backgroundImageStyle">
    <ElementBreadcrumb />
    <BaseButton
      clear
      :icon="iconType"
      :icon-position="'right'"
      @click.native="handleClick"
      v-if="!isMobile">
      {{ $t('message.common.topbar.toggle') }}
    </BaseButton>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import tomatoes from './_images/tomatoes.jpg'
import ElementBreadcrumb from '@elements/ElementBreadcrumb'
import BaseButton from '@base/BaseButton'

export default {
  name: 'TheTopbar',
  props: {},
  data () {
    return {
      backgroundImage: tomatoes
    }
  },
  computed: {
    ...mapGetters({
      device: 'breakpoints/getDevice',
      isVisible: 'myspace/getIsVisible'
    }),
    isMobile () {
      return this.device !== 'desktop'
    },
    backgroundImageStyle () {
      return `background-image: url(${this.backgroundImage});`
    },
    iconType () {
      return this.isVisible ? 'cross' : 'menu'
    }
  },
  components: {
    ElementBreadcrumb,
    BaseButton
  },
  methods: {
    ...mapActions({
      updateIsVisible: 'myspace/updateIsVisible'
    }),
    handleClick () {
      this.updateIsVisible()
    }
  }
}
</script>

<style lang="scss">
  .topbar{
    @media print {
      display: none !important;
    }
    $overlay-color: rgba(colors("topbar"), 0.8);
    $link-color: white;
    $link-color-hover: colors("spotlight");

    @include add-overlay($overlay-color);
    width: 100%;
    height: 7.8rem;
    padding: layout("spacing");
    z-index: 0;

    display: flex;
    justify-content: space-between;
    align-items: center;

    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-color: colors("foreground");

    > *{
      flex: 0 1 auto;
    }

    .breadcrumb{
      flex: 1;
      z-index: 1;
    }

    .button{
      @include hover{
        color: $link-color-hover;
      }

      color: $link-color;
      z-index: 1;

      .icon-cross{
        font-size: 1.4rem;
      }

      .icon-menu{
        font-size: 2.3rem;
      }
    }
  }
</style>
